import './Footer.css';
import { Navbar, Container, Row, Col, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import packageJson from '../../../package.json'; // Make sure this path is correct

const Footer = () => {
  return (
    <Navbar bg="dark" variant="dark" fixed="bottom" className="shadow-sm">
      <Container>
        <Row className="w-100">
          {/* Left Section */}
          <Col
            md={6}
            className="d-flex flex-column align-items-center align-items-md-start justify-content-center text-center text-md-start"
          >
            <Navbar.Text className="footer-text">
              Version: {packageJson.version}. Copyright &copy;{' '}
              {new Date().getFullYear()} Aparna Western Meadows. All rights
              reserved.
            </Navbar.Text>
          </Col>

          {/* Right Section */}
          <Col
            md={6}
            className="d-flex justify-content-center justify-content-md-end align-items-center footer-right-section"
          >
            <Nav>
              <Nav.Link as={Link} to="/faq" className="footer-link">
                FAQ
              </Nav.Link>
              <Nav.Link as={Link} to="/board-members" className="footer-link">
                EC MEMBERS
              </Nav.Link>
            </Nav>
          </Col>
        </Row>
      </Container>
    </Navbar>
  );
};

export default Footer;
